import React from "react";

export const formatLogDate = (date) => {
    if (!date) {
        return "—";
    }
    return new Date(date).toLocaleString("ru-RU", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
};

/** Текст с выделением фрагментов в [квадратных скобках] цветом primary */
export const renderBracketHighlightedText = (text) => {
    if (!text) {
        return "—";
    }

    const parts = [];
    const regex = /\[([^\]]*)\]/g;
    let lastIndex = 0;
    let match;

    while ((match = regex.exec(text)) !== null) {
        if (match.index > lastIndex) {
            parts.push(text.slice(lastIndex, match.index));
        }
        parts.push(
            <span key={`${match.index}-${match[1]}`} className="admin-logs__highlight">
                {match[1]}
            </span>,
        );
        lastIndex = regex.lastIndex;
    }

    if (lastIndex < text.length) {
        parts.push(text.slice(lastIndex));
    }

    return parts.length > 0 ? parts : text;
};

export const LOG_TYPE_OPTIONS = [
    { value: 1, label: "Вход в систему и действия" },
    { value: 2, label: "Покупки и пополнения баланса" },
    { value: 3, label: "Вопросы и жалобы" },
];

export const PAGE_LIMIT_OPTIONS = [
    { value: 10, label: "10" },
    { value: 15, label: "15" },
    { value: 20, label: "20" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
];

/** Дата из input[type=date] → ISO для API */
export const formatLogFilterDate = (dateStr, endOfDay = false) => {
    if (!dateStr) {
        return undefined;
    }
    return endOfDay ? `${dateStr}T23:59:59Z` : `${dateStr}T00:00:00Z`;
};

/** width: fit — по контенту; wide — гибкая колонка (2fr) */
export const LOG_TABLE_COLUMNS = {
    1: [
        { id: "accountId", label: "ID Ак.", width: "fit" },
        { id: "destinationCharID", label: "ID чата", width: "fit" },
        { id: "login", label: "Логин", width: "default" },
        { id: "characterName", label: "Персонаж", width: "default" },
        { id: "date", label: "Дата", width: "fit" },
        { id: "text", label: "Действие", width: "wide" },
    ],
    2: [
        { id: "characterName", label: "Персонаж", width: "default" },
        { id: "targetCharacterName", label: "Целевой персонаж", width: "default" },
        { id: "oldValue", label: "Изначально", width: "fit" },
        { id: "newValue", label: "Стало", width: "fit" },
        { id: "amount", label: "Количество", width: "fit" },
        { id: "reason", label: "Причина", width: "wide" },
        { id: "date", label: "Дата", width: "fit" },
    ],
    3: [
        { id: "playerLogin", label: "Логин", width: "default" },
        { id: "characterName", label: "Персонаж", width: "default" },
        { id: "date", label: "Дата", width: "fit" },
        { id: "text", label: "Сообщение", width: "wide" },
        { id: "type", label: "Статус", width: "fit" },
    ],
};
